import catchReduxError from './catch-redux-error';
import createEditorError from './create-editor-error';

export default {
  catchReduxError,
  createEditorError,
};
